import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PowerBiReportParameters, PowerBiReport } from '../../models/power-bi-report';
import { PowerBiService } from '../../services/power-bi.service';

@Component({
    selector: 'app-power-bi-report',
    templateUrl: './power-bi-report.component.html',
    styleUrls: ['./power-bi-report.component.scss'],
    standalone: false
})
export class PowerBiReportComponent implements OnInit {

    _report: PowerBiReport | null = null;
    embed: string = '';

    @Input() set report(val: PowerBiReport | null) {
        this._report = val;

        if (val)
            this.embed = this.pbiService.getReportUrl(val, this.params);
    }

    @Input() params: PowerBiReportParameters[] = [];

    constructor(private pbiService: PowerBiService) { }


    ngOnInit(): void {
        if (this._report)
            this.embed = this.pbiService.getReportUrl(this._report, this.params);
    }

}

